module.exports = __webpack_public_path__ + "assets/198ed3e2-0cdf-496f-a0ef-86da8d4dde55.b082f44d.svg";